<template>

	<div>
		<page-title-bar></page-title-bar>
		<app-section-loader :status="loader"></app-section-loader>

	<v-container fluid grid-list-xl pt-0>
			<app-card>
				<v-btn color="default" @click="cancel" name="btncancel" >Terug</v-btn>
			</app-card>
            <app-card>
            
               <v-tabs icons-and-text  color="#fff">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-basic">
                        Basis info
                        <v-icon>face</v-icon>
                    </v-tab>
                    <div v-show="hideExtraBlock === false">
                    <v-tab href="#tab-appoints">
                        Afspraken
                        <v-icon>calendar_today</v-icon>
                    </v-tab>
                    </div>

                    <!-- BASIS INFO BLOK -->
                    <v-tab-item :id="'tab-basic'">
                    <v-card flat>
                    <v-card-text>
                        <div v-if="this.kindrec === 0">
                          <customer-basic-tab :record="this.record"  :isNew="this.isNew"></customer-basic-tab>
                        </div>
                        <div v-else>
                          <supplier-basic-tab :record="this.record"></supplier-basic-tab>
                        </div>
                        
                    </v-card-text>
                    </v-card>
                    </v-tab-item>
                    <!-- AFSPRAKEN INFO BLOK -->
                    <v-tab-item :id="'tab-appoints'">
                    <v-card flat>
                    <v-card-text>
                        <customer-appoints-tab :record="this.record"></customer-appoints-tab>
                    </v-card-text>
                    </v-card>
                    </v-tab-item>
                </v-tabs>
                
			</app-card>
		</v-container>
	</div>
</template>
<script>

import CustomerBasicTab from "Components/Customer/CustomerBasicTab";
import CustomerAppointsTab from "Components/Customer/CustomerAppointsTab";

import myHttpApi from "../../api/myHttpApi";
import router from '../../router';

export default {
   props: {
       id : String,
       kindrec : Number,
       isNew : Boolean
    },
  data() {
    return {
        loader: true,
        disable: false,
        record: {},
        hideExtraBlock : false
    };
  },
   components: {
     CustomerBasicTab,
     CustomerAppointsTab,
  },
  mounted() {
    
    if (this.kindrec == 1) {this.hideExtraBlock = true;}
    if (this.isNew) {this.hideExtraBlock = true;}
    this.getTableData()
  },
  methods: {
    cancel ()  {
        router.go (-1);
    },
    save () {
        myHttpApi.post('BOCustomer/Save', this.record.Customer)
        .then(response => {
            this.loader = false;
            this.disable = true;
        })
        .catch(error => {
            console.log(error);
        });
    },
    getTableData() {
      myHttpApi
		const searchRec = {Search: this.id, Extra: ""}
		myHttpApi.post('BOCustomer/Get', searchRec)
        .then(response => {
          this.loader = false;
          this.record = response.data;

          if (this.record.Tickets == null) {this.record.Tickets = [];}
          if (this.record.Appointments == null) {this.record.Appointments = [];}
        })
        .catch(error => {
          console.log(error);
        });
	}
  }
};
</script>
